<template>
    <div class="quotes-loader">
        <div class="container">
            <transition name="fade-slide">

                <figure
                    v-if="currentQuote"
                    class="quotes-loader__quote">
                    <blockquote>{{ currentQuote.quotes }}</blockquote>
                    <figcaption>{{ currentQuote.author }}</figcaption>
                </figure>
            </transition>

        </div>
        <HorizontalBubbleLoader />
    </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import axios from "axios";

import { random } from "@/utils/utils";
import { cleanLocale } from "@/utils/helpers/translation/translation.js";

import HorizontalBubbleLoader from "@/components/loaders/HorizontalBubbleLoader.vue";


export default {
    name: "QuotesLoader",
    components: {
        HorizontalBubbleLoader: HorizontalBubbleLoader
    },
    props: {
        max: {
            type: Number,
            required: false,
            default: 0
        },
    },
    data() {
        return {
            progress: 0,
            uniqueId: uuidv4(),
            interval: null,
            quotes: null,
            quotesIndex: null,
            lastQuotesIndex: null,
            resetQuoteTimeout: null,
            changeQuoteTimeout: null,

        };
    },
    computed: {
        currentQuote() {
            if (this.quotes && this.quotesIndex) {
                return this.quotes[this.quotesIndex];
            }
        },
        lang() {
            return cleanLocale(this.$i18n.locale);
        }
    },
    mounted() {
        this.fetchQuotes();

        if (this.max > 0) {
            this.start();
        }

    },
    destroyed() {
        clearInterval(this.interval);
    },
    methods: {
        start() {
            this.interval = setInterval(() => {

                this.progress += (1 / 100);

                if(this.progress >= this.max){
                    clearInterval(this.interval);
                    this.$emit("progress-complete");
                }
            }, 10);
        },
        finish() {
            clearInterval(this.interval);

            this.interval = setInterval(() => {
                this.progress += (1);

                if(this.progress >= this.max){
                    clearInterval(this.interval);
                    this.$emit("progress-complete");
                }
            }, 10);
        },
        fetchQuotes() {
            axios({
                url: `/json/quotes/quotes.${this.lang}.json`,
            }).then(res => {
                this.quotes = res.data;
                this.selectQuote();
            });
        },
        selectQuote() {
            let quotesIndex = Math.round(random(0, this.quotes.length - 1));

            while (quotesIndex === this.lastQuotesIndex) {
                quotesIndex = Math.round(random(0, this.quotes.length - 1));
            }

            this.quotesIndex = quotesIndex;

            clearTimeout(this.resetQuoteTimeout);
            clearTimeout(this.changeQuoteTimeout);

            this.resetQuoteTimeout = setTimeout(() => {
                this.lastQuotesIndex = this.quotesIndex;
                this.quotesIndex = null;
            }, 9000);

            this.changeQuoteTimeout = setTimeout(() => {
                this.selectQuote();
            }, 10000);
        }

    }
};
</script>

